import { AuthorityType } from '@/types'

export interface GetAuthorityRequest {
  authorityType: AuthorityType
  authorityNo: string
  isEdit: boolean
}

export function GetAuthorityRequestToJSON(value: GetAuthorityRequest): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    authority_no: value.authorityNo !== '' ? value.authorityNo : undefined,
    is_edit: value.isEdit ?? undefined
  }
}
